import React, { useRef } from "react";
import styled from "styled-components";

class ParallaxTiltEffect {
    element: HTMLElement;
    container: HTMLElement;
    w: number;
    h: number;
    tiltEffect: string;
    mouseOnComponent: boolean;
    // offSetY: any;
    // offSetX: any;

    constructor({ element, container, tiltEffect }: { element: any; container: any; tiltEffect: string }) {
        this.element = element;
        this.container = container;

        [this.w, this.h] = [element.clientWidth, element.clientHeight];
        // [this.offSetX, this.offSetY] = [element.offsetLeft, element.offsetTop];
        this.tiltEffect = tiltEffect;
        this.mouseOnComponent = false;
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.defaultStates = this.defaultStates.bind(this);
        this.setProperty = this.setProperty.bind(this);
        this.init = this.init.bind(this);
        this.init();
    }
    handleMouseMove(e) {
        // normalise touch/mouse
        var pos = [e.layerX, e.layerY]; //[e.clientX - this.element.offsetLeft, e.clientY - this.element.offsetTop];
        e.preventDefault();
        if (e.type === "touchmove") {
            pos = [e.touches[0].clientX, e.touches[0].clientY];
        }
        // var $card = $(this);
        // math for mouse position
        var l = pos[0];
        var t = pos[1];
        var h = this.h;
        var w = this.w;
        var px = Math.abs(Math.floor((100 / w) * l) - 100);
        var py = Math.abs(Math.floor((100 / h) * t) - 100);
        var pa = 50 - px + (50 - py);
        // math for gradient / background positions
        var lp = 50 + (px - 50) / 1.5;
        var tp = 50 + (py - 50) / 1.5;
        var px_spark = 50 + (px - 50) / 7;
        var py_spark = 50 + (py - 50) / 7;
        var p_opc = (20 + Math.abs(pa) * 1.5) / 100;
        var ty = ((tp - 50) / 2) * -1;
        var tx = ((lp - 50) / 1.5) * 0.5;

        //rotate
        this.setProperty("--rY", `${tx}deg`);
        this.setProperty("--rX", `${ty}deg`);
        //holo
        this.setProperty("--lp", `${lp}%`);
        this.setProperty("--tp", `${tp}%`);
        //sparkle
        this.setProperty("--px", `${px_spark}%`);
        this.setProperty("--py", `${py_spark}%`);
        this.setProperty("--p_opc", `${p_opc}`);

        if (e.type === "touchmove") {
            return false;
        }
    }
    handleMouseEnter() {
        this.mouseOnComponent = true;
        this.container.classList.add("parallaxTilt--active");
    }
    handleMouseLeave() {
        this.mouseOnComponent = false;
        this.defaultStates();
    }
    defaultStates() {
        this.container.classList.remove("parallaxTilt--active");
        this.setProperty("--rY", 0);
        this.setProperty("--rX", 0);

        this.setProperty("--lp", "50%");
        this.setProperty("--tp", "50%");

        this.setProperty("--px", "50%");
        this.setProperty("--py", "50%");
        this.setProperty("--p_opc", `0`);
    }
    setProperty(p, v) {
        return this.container.style.setProperty(p, v);
    }
    init() {
        this.element.addEventListener("mousemove", this.handleMouseMove);
        this.element.addEventListener("mouseenter", this.handleMouseEnter);
        this.element.addEventListener("mouseleave", this.handleMouseLeave);
    }
}

const ParallaxTiltContainer = styled.default.div`
    position: relative;
    --rX: 0;
    --rY: 0;
    --lp: 50%;
    --tp: 50%;
    --px: 50%;
    --py: 50%;
    --color1: #ec9bb6;
    --color2: #ccac6f;
    --color3: #69e4a5;
    --color4: #8ec5d6;
    --color5: #b98cce;
    transform: rotateX(var(--rX)) rotateY(var(--rY));
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-opacity: 0.5;
    transform-origin: center;
    overflow: hidden;
    transition: transform 1s 0s;
    border-radius: 12px;

    &.parallaxTilt--active {
        transition: none;
        :before,
        :after {
            transition: none;
        }
    }

    :before,
    :after {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background-repeat: no-repeat;
        opacity: 0.5;
        mix-blend-mode: color-dodge;
        transition: transform 1s 0s, background-position 1s 0s, opacity 1s 0s;
        background-blend-mode: overlay;
    }
    :before {
        content: ${(props) => (props.holo ? "''" : "none")};
        background-position: var(--lp) var(--tp);
        background-size: 300% 300%;
        background-image: linear-gradient(115deg, transparent 20%, var(--color1) 36%, var(--color2) 43%, var(--color3) 50%, var(--color4) 57%, var(--color5) 64%, transparent 80%);
        opacity: 0.1;
        filter: brightness(0.5) contrast(1);
        z-index: 1;
    }
    :hover:before {
        opacity: 0.8;
        filter: brightness(0.66) contrast(1.33);
        background-size: 250% 250%;
    }
    :after {
        content: ${(props) => (props.sparkle ? "''" : "none")};
        background-position: var(--px) var(--py);

        background-image: url("/images/sparkles.gif"), linear-gradient(125deg, #ff008450 15%, #fca40040 30%, #ffff0030 40%, #00ff8a20 60%, #00cfff40 70%, #cc4cfa50 85%);

        background-size: 160%;
        background-blend-mode: overlay;
        z-index: 2;
        filter: brightness(1) contrast(1);
        transition: all 0.33s ease;
        mix-blend-mode: color-dodge;
        opacity: 0.1;
    }
    :hover:after {
        background-position: var(--px) var(--py);
        background-image: url("/images/sparkles.gif"), linear-gradient(125deg, #ff008450 15%, #fca40040 30%, #ffff0030 40%, #00ff8a20 60%, #00cfff40 70%, #cc4cfa50 85%);
        background-size: 160%;
        background-blend-mode: overlay;
        z-index: 2;
        filter: brightness(1) contrast(1);
        transition: all 0.33s ease;
        mix-blend-mode: color-dodge;
        opacity: var(--p_opc); 
    }
`;

const ParallaxWrap = styled.default.div`
    //transform-style: preserve-3d;
    // transform: perspective(100rem);
    transform: translate3d(0.1px, 0.1px, 0.1px);
    perspective: 2000px;
    display: flex;
    margin-bottom:15px;
`;

const ParallaxTilt = ({ children, tilt = true, ...props }) => {
    const [tiltEffect, setTiltEffect] = React.useState({});
    const ref = useRef(null);
    const containerRef = useRef(null);
    React.useEffect(() => {
        if (tilt !== false) {
            setTiltEffect(
                new ParallaxTiltEffect({
                    element: ref.current,
                    container: containerRef.current,
                    tiltEffect: "normal",
                })
            );
        }
    }, [ref, containerRef, tilt]);

    return (
        <ParallaxWrap ref={ref}>
            <ParallaxTiltContainer ref={containerRef} {...props}>
                {children}
            </ParallaxTiltContainer>
        </ParallaxWrap>
    );
};

export default ParallaxTilt;
